<template>
    <div class="app_detail" v-bkloading="{ isLoading: appLoading }">
        <section class="top-wrapper">
            <div :class="['product-detail', { 'fold': !showMore }]" v-if="Object.keys(appDetail).length">
                <div class="product-detail-header">
                    <span class="go-back" @click="$router.push({ path: '/s-mart/market' })">市场 /</span>
                    <span class="product-detail-text">产品详情</span>
                </div>
                <div class="detail-content">
                    <div class="left-content column-layout">
                        <div class="product-logo">
                            <img :src="appDetail.app_logo" alt="">
                            <img
                                v-if="appDetail.pay_type === 3"
                                class="inquiry"
                                src="../images/application_detail/inquiry-radius.png"
                                alt="">
                        </div>
                        <h4 class="product-name">{{ appDetail.name }}</h4>
                        <div class="scoring-like">
                            <el-rate
                                class="star-rate"
                                v-model="appDetail.star"
                                :disabled="true"
                                void-icon-class="el-icon-star-on"
                                disabled-void-color="#c4c6cc"
                                :colors="['#fe9c00', '#fe9c00', '#fe9c00']">
                            </el-rate>
                            <span>{{ appDetail.star }}分</span>
                            <el-tooltip class="item" effect="dark" :content="isCollect ? '取消收藏' : '添加收藏'" placement="top">
                                <span :class="['icon-heart', { 'icon-heart-shape': isCollect }]" @click="handleCollect"></span>
                            </el-tooltip>
                            {{ appDetail.fan_num }}
                        </div>
                    </div>
                    <div class="center-content column-layout">
                        <ul class="product-info">
                            <li
                                class="info-item"
                                v-for="(item, index) in appOpitons"
                                :key="index">
                                <label>{{ item.label }} : </label>
                                <div class="info-content">
                                    {{ (item.isArrary ? appDetail[item.key].join('，') : appDetail[item.key]) || '--' }}
                                </div>
                            </li>
                            <li class="info-item">
                                <label>发布者 : </label>
                                <div class="info-content">
                                    <span class="user-name">{{ appDetail.user.nick_name }}</span>
                                    <template v-for="(badge, index) in badgeList">
                                        <el-tooltip
                                            v-if="appDetail.user.user_badges[index]"
                                            :key="index"
                                            :content="badge.text"
                                            effect="dark"
                                            placement="top">
                                            <img class="icon-medal" :src="badge.url" alt="">
                                        </el-tooltip>
                                    </template>
                                </div>
                            </li>
                        </ul>
                        <div class="product-desc">
                            <div class="introduction">作品简介 : </div>
                            <p class="description" v-html="filterXSS(appDetail.desc)"></p>
                        </div>
                    </div>
                    <div class="right-content column-layout">
                        <template v-if="appDetail.pay_type !== 3">
                            <span
                                class="download-btn" @click="download">
                                <img src="../images/application_detail/icon-download-5.png" alt="">
                                立即下载
                            </span>
                            <div class="download-num">
                                <span>大小 : </span>
                                <span class="num">{{ appDetail.size || '--' }}</span>
                                <span>下载次数 : </span>
                                <span class="num">{{ appDetail.download_num }}</span>
                            </div>
                        </template>
                        <span
                            v-else
                            class="download-btn"
                            @click="popupShow = true; goTrack('', false, 'detail-advisory')">
                            立即询价
                        </span>
                        <div class="share share-area">
                            <span>分享给朋友：</span>
                            <div class="social-share"></div>
                        </div>
                    </div>
                </div>
                <div v-if="displayMoreIcon" class="more-content">
                    <div class="more-content-btn" @click="changeShow">
                        {{ showMore ? '收起' : '更多' }}
                        <i class="el-icon-arrow-down" v-if="!showMore"></i>
                        <i class="el-icon-arrow-up" v-else></i>
                    </div>
                </div>
            </div>
        </section>
        <section :class="['router-wrapper', {'is-fixed': isFixed}]">
            <div class="router-list">
                <router-link
                    class="router-item"
                    v-for="(item, index) in routerList"
                    :key="index"
                    :to="item.to">
                    <span @click="handleRouter(item.track)">{{ item.name }}</span>
                </router-link>
            </div>
            <div class="route-content">
                <router-view
                    :user="user"
                    :badge-list="badgeList"
                    :app-detail="appDetail">
                </router-view>
            </div>
        </section>
        <popup :show="popupShow" class="whale-coin" @close="closePopup">
            <ul slot="popup-body" class="whale-content">
                <li class="clearfix">
                    <p class="title">作品名称：</p>
                    <p class="work-name">列出占用系统资源最高的十个进程</p>
                </li>
                <li class="clearfix">
                    <p class="title">鲸币：</p>
                    <p class="coin-num">325</p>
                </li>
                <li class="clearfix">
                    <p class="title">服务协议：</p>
                    <p class="agreement">一年内免费版本升级</p>
                </li>
                <li class="clearfix">
                    <p class="title">鲸币余额：</p>
                    <p class="balance">1200</p>
                </li>
            </ul>
            <div slot="popup-footer" class="whale-button">
                <a href="javascript:;" class="confirm-button">确认购买</a>
            </div>
        </popup>
        <popup :show="popupShow" class="public" @close="closePopup">
            <div slot="popup-body">
                <div class="public-content" v-if="appDetail.pay_type === 3">
                    <div class="round"><img src="../images/application_detail/pops-download.png" alt="" /></div>
                    <p class="text">正在为您自动下载“{{appDetail.name}}”</p>
                    <p class="tips">如果您的浏览器不支持自动下载，请手动下载该作品</p>
                    <p v-if="appDetail.pay_type === 3 && downloadUrl === ''" class="confirm-button disabled">下载地址</p>
                    <a v-else :href="downloadUrl" class="confirm-button">下载地址</a>
                </div>
                <div class="public-content consult" v-if="appDetail.pay_type === 3">
                    <div class="round"><img src="../images/application_detail/pops-phone.png" alt="" /></div>
                    <p class="phone">{{appDetail.company_phone}}</p>
                    <p class="text">请联系应用提供商<strong>“{{appDetail.user.nick_name}}”</strong>进行咨询</p>
                    <p class="tips">该作品未开放下载购买</p>
                    <router-link :to="{path:'/s-mart/personal_center/user/'+appDetail.user.id}" class="detail-button">查看服务商详情</router-link>
                </div>
                <div class="public-content warning hide">
                    <div class="round"><i><img src="../images/application_detail/pops-waring.png" alt="" /></i></div>
                    <p class="text">文件编译失败，请联系客服解决</p>
                    <p class="tips">错误码：134</p>
                    <a href="javascript:;" class="confirm-button white">联系客服</a>
                </div>
                <div class="public-content hide">
                    <div class="round tempo"><span class="number">12</span>%</div>
                    <p class="text">正在为您编译文件，大约需要1分钟，请稍后..</p>
                    <div class="tips">
                    <p>初次下载该作品需要经过较长的编译时间</p>
                    <p>您也可以关闭该弹层，先去浏览下其他作品</p>
                    </div>
                </div>
                <div class="public-content hide">
                    <div class="round tempo"><span class="number">78</span>%</div>
                    <p class="text">正在为您生成个人编译器，大约需要2分钟，请稍后..</p>
                    <div class="tips">
                    <p>后续使用过程中不会再重复生成，可以在用户中心下载自己的编译器</p>
                    </div>
                </div>
                <div class="loading-box hide">
                    <div class="loading">
                        <div
                            v-for="item in 12"
                            :key="item"
                            :class="`strip strip${item}`">
                        </div>
                    </div>
                </div>
            </div>
        </popup>
        <img src="../images/personal_center/avatar_default.png" alt="" style="display:none;" id="avatar_default">
        <!-- 返回顶部 -->
        <div class="back-top" v-if="isShowBackTop" @click="goBackTop"></div>
    </div>
</template>

<script type="text/javascript">
    import popup from './popup.vue'
    import bus from '@/js/bus.js'

    export default {
        filters: {
            formatSize(num) {
                num += ''
                let x = num.split('.')
                let x1 = x[0]
                let x2 = x.length > 1 ? '.' + x[1] : ''
                let rgx = /(\d+)(\d{3})/
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + ',' + '$2')
                }
                return x1 + x2
            }
        },
        props: {
            user: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            const routerList = [
                {
                    to: 'detail',
                    name: '产品预览'
                }, {
                    to: 'histroy',
                    name: '版本列表'
                }, {
                    to: 'information',
                    name: '产品资料'
                }, {
                    to: 'comment',
                    name: '产品评论',
                    track: 'detail-tabs-comment'
                }
            ]
            const appOpitons = [
                {
                    label: '首发时间',
                    key: 'create_time'
                }, {
                    label: '浏览器兼容',
                    isArrary: true,
                    key: 'browser'
                }, {
                    label: '最近更新时间',
                    key: 'update_time'
                }, {
                    label: '部署环境',
                    isArrary: true,
                    key: 'deploy_env'
                }, {
                    label: '当前版本号码',
                    key: 'current_version'
                }, {
                    label: '语言支持',
                    isArrary: true,
                    key: 'i18n'
                }, {
                    label: '作品类型',
                    key: 'sys_type'
                }, {
                    label: '关联标签',
                    isArrary: true,
                    key: 'category'
                }, {
                    label: '开发语言',
                    isArrary: true,
                    key: 'language'
                }, {
                    label: '蓝鲸版本依赖',
                    key: 'bk_version'
                }, {
                    label: '文件大小',
                    key: 'size'
                }
            ]
            const badgeList = [
                {
                    text: '官方授权服务商',
                    url: require('@/images/application_detail/medal4.png')
                }, {
                    text: '蓝鲸官方',
                    url: require('@/images/application_detail/medal.png')
                }, {
                    text: '企业认证',
                    url: require('@/images/application_detail/medal2.png')
                }, {
                    text: '实名认证',
                    url: require('@/images/application_detail/medal3.png')
                }, {
                    text: '蓝鲸开发者认证',
                    url: require('@/images/application_detail/medal5.png')
                }
            ]
            return {
                isFixed: false, // 是否吸顶
                isShowBackTop: false,
                showMore: false,
                displayMoreIcon: true,
                appDetail: {},
                routerList,
                appOpitons,
                badgeList,
                star_user: 0,
                infoPopup: false,     // 完善信息弹窗状态
                isFirstIn: false,     // 是否第一次登录
                isCollect: false,     // 是否收藏
                downloadUrl: "",      // 下载链接
                popupShow: false,     // 下载弹窗状态
                shareUrl: "",         // 分享链接
                shareText: "",        // 分享文本
                sharePic: "",         // 分享图片
                appLoading: true,
            }
        },
        async mounted()  {
            window.addEventListener('scroll', this.handleScroll)
            await this.initPage()
            this.shareUrl =  window.location.href
            this.$nextTick(() => {
                $(window).scrollTop(0)
            })
            let $config = {
                url: this.shareUrl,
                description: this.shareText,
                title: this.appDetail.name,
                image: this.sharePic,
                sites: ['qzone', 'weibo','wechat'], // 启用的站点
                wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
                wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>'
            }
            socialShare('.social-share',$config)
            // 这里是为了等 dom 加载完后计算真实高度
            setTimeout(() => {
                const infoDom = document.querySelector('.product-info')
                const descDom = document.querySelector('.product-desc')
                let height = 0
                height = infoDom.offsetHeight + descDom.offsetHeight
                this.displayMoreIcon = height >= 235
            }, 100)
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        computed: {
            isLogin () {
                return this.$store.state.isLogin
            }
        },
        methods: {
            handleRouter (track) {
                if (track) {
                    this.goTrack('', false, track)
                }
            },
            /*
            ** 百度统计
            */
            goTrack (url, status, action) {
                _hmt.push(['_trackPageview', url])
                _hmt.push(['_trackEvent', action, 'click'])
                
                if (status) {
                    this.$router.push({
                        path: url
                    })
                }
            },
            download() {
                
                axios.post(myUrl + "login/get_user_info/").then((res) => {
                    res = res.data
                    if (res.result) {
                        if (res.result) {  // 已注册
                            // 校验信息是否完善
                            if (!this.$store.state.informationComplete) {
                                bus.$emit('openInformationPopup', 'downLoad')
                                return
                            }
                            // this.popupShow = true;
                            // 获取下载链接
                            axios.post(myUrl + "core/product/download/" + this.$route.params.aid + "/").then((res) => {
                                res = res.data
                                if (res.result) {
                                    this.downloadUrl = res.data
                                    window.location.href = this.downloadUrl
                                    this.appDetail.download_num += 1
                                } else {
                                    console.log(res.message)
                                }
                            })
                        } else {
                            bus.$emit('openInformationPopup')
                        }
                    }
                }).catch((res) => {
                    console.warn(res)
                })
            },
            closePopup () {
                this.currentView = ''
                this.popupShow = false
            },
            handleCollect () {
                if (!this.isLogin) {
                    //请求登录
                    axios.post(myUrl + "login/get_user_info/")
                    return
                }
                // 校验信息是否完善
                if (!this.$store.state.informationComplete) {
                    bus.$emit('openInformationPopup');
                    return;
                }
                if (this.isCollect) {
                    this.unfavoriteApp()
                } else {
                    this.collectApp()
                }
            },
            collectApp () {  // 收藏作品
                axios.post(myUrl + "sns/collect/product/" + this.$route.params.aid + "/").then(res => {
                    const resp = res.data
                    if (resp.result) {
                        this.isCollect = true
                        this.appDetail.fan_num++
                    }else {
                        console.log(resp.message)
                    }
                })
            },
            unfavoriteApp () {  // 取消作品收藏
                axios.post(myUrl + "sns/unfavorite/product/" + this.$route.params.aid + "/").then(res => {
                    const respr= res.data
                    if (resp.result) {
                        this.isCollect = false
                        this.appDetail.fan_num--
                    }else {
                        console.log(resp.message)
                    }
                })
            },
            setShareText () {  //设置分享文本内容
                if (this.appDetail.sys_type == "脚本工具") {
                    this.shareText = "我在蓝鲸S-mart市场发现一个超好用的脚本，推荐给你"
                } else {  // 应用系统
                    this.shareText = "我在蓝鲸S-mart市场找到一款超赞的应用APP，推荐给你"
                }
                this.sharePic += this.appDetail.app_show.join('||')
            },
            async initPage () {
                // 获取页面主要数据
                await axios.get(myUrl + "core/product/"+this.$route.params.aid+"/").then(res => {
                    const resp = res.data
                    if (resp.result) {
                        const {
                            is_collected,
                            logo_left,
                            logo_mid,
                            logo_right,
                            user,
                            on_line_version,
                            star_1,
                            star_2,
                            star_3,
                            star_4,
                            star_5
                        } = resp.data
                        const appShows = [
                            logo_left && logo_left.access_url,
                            logo_mid && logo_mid.access_url,
                            logo_right && logo_right.access_url
                        ]
                        const starUser = [star_5, star_4, star_3, star_2, star_1]
                        resp.data.app_show = appShows
                        resp.data.current_version = on_line_version.current_version
                        resp.data.star_user = starUser
                        this.isCollect = is_collected
                        this.appDetail = resp.data
                        //设置分享文本内容
                        this.setShareText()
                        setTimeout(() => {
                            user.avatar = user.avatar.indexOf('?') !== 0 ? user.avatar : document.querySelector('#avatar_default').getAttribute('src')
                        }, 0)

                    } else {
                        console.log(resp.message)
                        this.$router.push("/404")
                    }
                    this.appLoading = false
                })
            },
            changeShow () {
                this.showMore = !this.showMore
            },
            handleScroll () {
                this.isShowBackTop = window.scrollY > 0
                // 路由tab栏吸顶
                this.isFixed = window.scrollY >= 315
            },
            // 返回顶部
            goBackTop () {
                scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            }
        },
        components: {
            popup
        }
    }
</script>
<style lang="scss">
    .el-rate .el-rate__item .el-rate__icon {
        margin-right: 0;
        font-size: 14px;
        height: auto;
    }
    .star-rating .el-rate__item .el-rate__icon{
        font-size: 20px;
    }
    .wechat-qrcode {
        z-index: 100001 !important;
    }
</style>

<style media="screen" lang="scss" scoped>
    .app_detail {
        position: relative;
        background: #f5f7fa;
        .bk-icon {
            position: relative;
            top: 2px;
            margin-right: 10px;
        }
        .back-top {
            position: fixed;
            bottom: 49px;
            right: 96px;
            z-index: 222;
            width: 52px;
            height: 52px;
            border-radius: 26px;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.10); 
            background: #fff;
            background-image: url('../images/application_detail/angle-up.png');
            background-size: 32px 32px;
            background-position: 50% 50%;
            background-repeat: no-repeat;
            cursor: pointer;
            &:hover {
                background-image: url('../images/application_detail/hover-angle-up.png');
            }
        }
    }
    body{
        background: #fafbfd;
    }
    .swiper-pagination{
        bottom: 20px;
    }
    .top-wrapper {
        display: flex;
        justify-content: center;
        background: #fff;
        margin: 60px 0 16px;
        min-height: 290px;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.10);
    }
    .product-detail {
        width: 1219px;
        font-size: 12px;
        padding-bottom: 30px;
        position: relative;
        &.fold {
            max-height: 320px;
            .center-content {
                max-height: 255px;
                overflow: hidden;
            }
        }
        .product-detail-header {
            margin: 16px 0 23px;
            color: #979ba5;
            line-height: 22px;
            .go-back:hover {
                color: #3a84ff;
                cursor: pointer;
            }
            .product-detail-text {
                color: #313238;
                margin-left: 2px;
            }
        }
    
        .detail-content {
            display: flex;
            line-height: 24px;
            .column-layout {
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .left-content {
                width: 200px;
                margin-right: 40px;
                padding: 3px;
                .product-logo {
                    width: 120px;
                    height: 120px;
                    background: #f0f1f5;
                    border-radius: 16px;
                    padding: 18px;
                    position: relative;
                    img {
                        height: 100%;
                        width: 100%;
                        border-radius: 8px;
                    }
                    .inquiry {
                        width: 69px;
                        height: 59px;
                        position: absolute;
                        top: -2px;
                        left: -4px;
                        z-index: 5;
                    }
                }
                .product-name {
                    font-size: 16px;
                    color: #313238;
                    margin: 17px 0;
                    text-align: center;
                }
                .scoring-like {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: #63656e;
                    .star-rate {
                        height: auto;
                        margin-right: 9px;
                    }
                    .icon-heart {
                        width: 15px;
                        height: 15px;
                        position: relative;
                        top: 0px;
                        margin: 0 8px 0 15px;
                        cursor: pointer;
                        background: url(../images/application_detail/icon-heart2.png) no-repeat;
                        background-size: 100% 100%;
                        &:hover {
                            background: url(../images/application_detail/icon-heart3.png) no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                    .icon-heart-shape {
                        background: url(../images/application_detail/icon-heart3.png) no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
            .center-content {
                flex: 1;
                .product-info {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    .info-item {
                        width: 50%;
                        display: flex;
                        align-self: flex-start;
                        label {
                            text-align: left;
                            color: #63656e;
                            margin-right: 10px;
                            width: 80px;
                            flex-shrink: 0;
                            align-self: flex-start;
                        }
                        .info-content {
                            flex: 1;
                            display: flex;
                            align-items: center;
                            color: #313238;
                            .user-name {
                                margin-right: 6px;
                            }
                            .icon-medal {
                                height: 16px;
                                width: 16px;
                                margin-left: 4px;
                            }
                        }
                        &:nth-child(2n+1) {
                            .info-content {
                                padding-right: 30px;
                            }
                        }
                    }
                }
                .product-desc {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    color: #63656e;
                    margin-top: 15px;
                    line-height: 20px;
                    .introduction {
                        margin-right: 34px;
                        align-self: flex-start;
                    }
                    .description {
                        flex: 1;
                    }
                }
            }
            .right-content {
                margin-left: 40px;
                .download-btn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 160px;
                    height: 32px;
                    color: #fff;
                    background: #3a84ff;
                    font-size: 14px;
                    margin-bottom: 13px;
                    border-radius: 2px;
                    cursor: pointer;
                    img {
                        height: 14px;
                        width: 14px;
                        margin-right: 5px;
                    }
                }
                .download-num {
                    display: flex;
                    align-items: center;
                    color: #63656e;
                    margin-bottom: 27px;
                    .num {
                        font-weight: 700;
                        margin: 0 15px 0 3px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
                .share-area {
                    display: flex;
                    align-items: center;
                    color: #63656e;
                }
                .share {
                    .icon{
                        width: 20px;
                        height: 20px;
                        display: inline-block;
                        margin-left: 5px;
                        vertical-align: middle;
                        cursor: pointer;
                        position: relative;
                        font-style: normal;
                    }
                    .icon-qq-share {
                        background: url(../images/common/icon-qzone.png) no-repeat;
                        &:hover{
                            background-image: url(../images/common/icon-qzone-hover.png);
                            span{
                                display: block;
                            }
                        }
                        span{
                            display: none;
                            width: 120px;
                            height: 30px;
                            line-height: 30px;
                            font-size: 12px;
                            color: #fff;
                            background: #090b1a;
                            border-radius: 2px;
                            text-align: center;
                            position: absolute;
                            left: -48px;
                            top: -50px;
                            -webkit-transition: all 0.2s ease-out;
                            -moz-transition: all 0.2s ease-out;
                            -o-transition: all 0.2s ease-out;
                            -ms-transition: all 0.2s ease-out;
                            &::after{
                                content:'';
                                position: absolute;
                                left: 50%;
                                bottom: -14px;
                                width: 0;
                                height:0;
                                border: 10px solid #090b1a;
                                border-color: #090b1a transparent transparent transparent;
                                margin-left: -10px;
                            }
                        }
                    }
                    .icon-wechat2 {
                        background: url(../images/application_detail/icon-wechat2.png) no-repeat;
                        &:hover{
                            background-image: url(../images/application_detail/icon-wechat3.png);
                            .qr-code{
                                display: block;
                            }
                            span{
                                display: block;
                            }
                        }
                        span {
                            display:none;
                            width: 120px;
                            height: 30px;
                            line-height: 30px;
                            font-size: 12px;
                            color: #fff;
                            background: #090b1a;
                            border-radius: 2px;
                            text-align: center;
                            position: absolute;
                            right: -35px;
                            top: -50px;
                            -webkit-transition: all 0.2s ease-out;
                            -moz-transition: all 0.2s ease-out;
                            -o-transition: all 0.2s ease-out;
                            -ms-transition: all 0.2s ease-out;
                            &::after{
                                content:'';
                                position: absolute;
                                right: 30%;
                                bottom: -14px;
                                width: 0;
                                height:0;
                                border: 10px solid #090b1a;
                                border-color: #090b1a transparent transparent transparent;
                                margin-left: -10px;
                            }
                        }
                        .qr-code {
                            display: none;
                            font-size: 12px;
                            line-height: 15px;
                            color: #4f515e;
                            background: #fff;
                            padding: 13px 17px;
                            position: absolute;
                            right:-46px;
                            top:-170px;
                            text-align: center;
                            border: 1px solid #f4f4f4;
                            p{
                                margin-bottom: 7px;
                            }
                            &::after{
                                content:'';
                                width: 0px;
                                height: 0px;
                                border: 6px solid;
                                border-color: #fff transparent transparent transparent;
                                position:absolute;
                                right: 50px;
                                bottom:-12px;
                            }
                            &::before{
                                content:'';
                                width: 0px;
                                height: 0px;
                                border: 6px solid;
                                border-color: #f4f4f4 transparent transparent transparent;
                                position:absolute;
                                right: 50px;
                                bottom:-13px;
                            }
                        }
                    }
                    .icon-sina-share {
                        background: url(../images/application_detail/icon-sina.png) no-repeat;
                        background-size: cover;
                        &:hover{
                            background-image: url(../images/application_detail/icon-sina-hover.png);
                            span{
                                display: block;
                            }
                        }
                        span{
                            display:none;
                            width: 120px;
                            height: 30px;
                            line-height: 30px;
                            font-size: 12px;
                            color: #fff;
                            background: #090b1a;
                            border-radius: 2px;
                            text-align: center;
                            position: absolute;
                            right: -17px;
                            top: -50px;
                            -webkit-transition: all 0.2s ease-out;
                            -moz-transition: all 0.2s ease-out;
                            -o-transition: all 0.2s ease-out;
                            -ms-transition: all 0.2s ease-out;
                            &::after{
                                content:'';
                                position: absolute;
                                right: 15%;
                                bottom: -14px;
                                width: 0;
                                height:0;
                                border: 10px solid #090b1a;
                                border-color: #090b1a transparent transparent transparent;
                                margin-left: -10px;
                            }
                        }
                    }
                }
            }
        }
        .more-content {
            height: 30px;
            width: 100%;
            background: #fff;
            position: absolute;
            left: 50%;
            bottom: 0;
            z-index: 1;
            transform: translateX(-50%);
            display: flex;
            align-items: flex-end;
            justify-content: center;
            .more-content-btn {
                padding: 2px 20px;
                font-size: 12px;
                color: #fff;
                text-align: center;
                cursor: pointer;
                background: #c4c6cc;
                border-radius: 10px 10px 0px 0px;
                &:hover {
                    color: #ffffff;
                    background: #3a84ff;
                }
            }
            
        }
    }
    .router-wrapper {
        width: 1219px;
        min-height: 150px;
        margin: 0 auto 85px;
        background: #fff;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.10);
        padding: 0 24px 30px 15px;
        color: #63656e;
        .router-list {
            height: 57px;
            display: flex;
            align-items: center;
            background-image: linear-gradient(transparent 56px,#dcdee5 0);
            padding-left: 10px;
            margin-bottom: 20px;
            .router-item {
                width: 77px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                margin-right: 20px;
                cursor: pointer;
                color: #63656e;
                &.router-link-exact-active,
                &.active{
                    color: #3a84ff;
                    background-image: linear-gradient(transparent 55px,#3a84ff 0);
                }
                &:hover {
                    color: #3a84ff;
                }
            }
        }
        &.is-fixed {
            padding-top: 77px;
            .router-list {
                position: fixed;
                top: 60px;
                z-index: 9999;
                width: 1180px;
                background: #fff;
                background-image: linear-gradient(transparent 56px,#dcdee5 0);
            }
        }
    }
    .detail-button{
        display: inline-block;
        width:254px;
        height: 52px;
        line-height: 52px;
        text-align: center;
        color: #444444;
        font-size: 16px;
        border-radius: 3px;
        border: 1px solid #d6d6d6;
        margin-top: 30px;
    }
    .confirm-button{
        display: inline-block;
        width:254px;
        height: 52px;
        line-height: 52px;
        text-align: center;
        background: #57a3f1;
        border-radius: 3px;
        color: #fefeff;
        font-size: 16px;
        &:hover{
            background: #4491e1;
        }
        &.disabled{
            background: #98c6f5;
        }
        &.white{
            background: #fff;
            border: 1px solid #d6d6d6;
            color: #444444;
            &:hover{
                background: #fafafa;
            }
        }
    }
    .whale-coin{
        .s-popup-wrapper{
            width: 702px;
            min-height: 420px;
            border-radius: 4px;
            padding:0;
            .s-popup-header{
                padding: 20px;
            }
        }
        .whale-content{
            li{
                p{
                    float: left;
                    line-height: 50px;
                    color: #444;
                }
                .title{
                    width: 200px;
                    text-align: right;
                    font-size: 14px;
                    margin-right: 20px;
                }
                .work-name{
                    font-size: 16px;
                }
                .coin-num{
                    font-size: 24px;
                    color: #ffae00;
                }
                .agreement{
                    color: #888888;
                }
                .balance{
                    color: #888888;
                    font-size: 16px;
                }
            }
        }
        .whale-button{
            width: 100%;
            background: #fafafa;
            border-top: 1px solid #dddddd;
            text-align: center;
            margin-top: 20px;
            padding: 41px 0 45px;
        }
    }
    .public{
        .s-popup-wrapper{
            width: 800px;
            min-height: 480px;
            border-radius: 4px;
        }
        .loading-box{
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            .loading {
                width: 4px;
                height: 80px;
                position: relative;
                margin: 20px auto;
                .strip{
                    width: 100%;
                    height: 60%;
                    position: absolute;
                    &::before {
                        content: '';
                        display: block;
                        margin: 0 auto;
                        width: 100%;
                        height: 24%;
                        background-color: #000;
                        border-radius:6px 6px 0 0;
                        animation: stripFadeDelay 1.2s infinite ease-in-out both;
                    }
                }
                .strip2 { transform: rotate(30deg);}
                .strip3 { transform: rotate(60deg);}
                .strip4 { transform: rotate(90deg);}
                .strip5 { transform: rotate(120deg);}
                .strip6 { transform: rotate(150deg);}
                .strip7 { transform: rotate(180deg);}
                .strip8 { transform: rotate(210deg);}
                .strip9 { transform: rotate(240deg);}
                .strip10 { transform: rotate(270deg);}
                .strip11 { transform: rotate(300deg);}
                .strip12 { transform: rotate(330deg);}
                .strip2:before {animation-delay: -1.1s; }
                .strip3:before { animation-delay: -1s; }
                .strip4:before { animation-delay: -0.9s; }
                .strip5:before { animation-delay: -0.8s; }
                .strip6:before { animation-delay: -0.7s; }
                .strip7:before { animation-delay: -0.6s; }
                .strip8:before { animation-delay: -0.5s; }
                .strip9:before { animation-delay: -0.4s; }
                .strip10:before { animation-delay: -0.3s; }
                .strip11:before { animation-delay: -0.2s; }
                .strip12:before { animation-delay: -0.1s; }
                @-webkit-keyframes stripFadeDelay {
                    0%, 39%, 100% { opacity: 0.5; }
                    40% { opacity: 1; }
                }

                @keyframes stripFadeDelay {
                    0%, 39%, 100% { opacity: 0.5; }
                    40% { opacity: 1; }
                }
            }
        }
        .public-content{
            margin-top: 50px;
            text-align: center;
            &.consult{
                .tips{
                margin-top: 0;
                }
            }
            .round{
                width: 110px;
                height: 110px;
                line-height: 110px;
                border-radius: 50%;
                background: #fafafa;
                text-align: center;
                font-size: 42px;
                margin: 0 auto;
                color: #888888;
                &.tempo{
                    font-size: 16px;
                    background: #fff;
                    border:none;
                    color: #4f515e;
                    .number{
                        font-size: 60px;
                    }
                }
            }
            .phone{
                font-size: 20px;
                color: #4f515e;
                font-weight: bold;
            }
            .text{
                font-size: 16px;
                color: #4f515e;
                margin-top: 23px;
            }
            .tips{
                line-height: 30px;
                margin-top: 18px;
                color: #888;
            }
            .confirm-button{
                margin-top: 30px;
            }
            &.warning{
                .round{
                    background: #ff7979;
                    color: #fff;
                }
                .tips{
                    color: #d75a4a;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .bk-icon {
        font-size: 16px;
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// application_detail.vue?763c02a4